var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnVega(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .cls-1 {\n        fill: none;\n        stroke: currentColor;\n        stroke-width: 2px;\n        }\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1,
    y: 1,
    width: 34,
    height: 44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.14,27.65c0-4.89,3.97-8.86,8.86-8.86s8.86,3.97,8.86,8.86-3.97,8.86-8.86,8.86-8.86-3.97-8.86-8.86Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnVega);
export default __webpack_public_path__ + "static/media/icn_vega.14504023aa832289de1b39d866efbe69.svg";
export { ForwardRef as ReactComponent };